import Image from "next/image";
import { Button } from "./ui/button";
import React from "react";
import TransitionLink from "./transition-link";
import { PlaceHolderImages } from "../lib/placeholder-images";

export function OtherVisaPromotion() {
   const uaePromoImage = PlaceHolderImages.find(p => p.id === 'hero-travel');

  if (!uaePromoImage) {
    return null;
  }

  return (
    <section className="relative rounded-2xl overflow-hidden text-white p-8 md:p-12 min-h-[300px] flex flex-col justify-end items-start">
      {/* Background image */}
      <img
         src={uaePromoImage.imageUrl}
            alt={uaePromoImage.description}
        className="absolute inset-0 w-full h-full object-cover object-center"
     data-ai-hint={uaePromoImage.imageHint}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="relative z-10">
   <h2 className="text-4xl text-white font-bold">UAE Visas</h2>

        <TransitionLink to="/ksa-visa">
          <Button
            variant="secondary"
            className="mt-4 bg-white text-black hover:bg-neutral-200 rounded-full px-8 py-6 text-lg"
          >
            Explore
          </Button>
        </TransitionLink>
      </div>
    </section>
  );
}
